export interface DocBlock {
	class: DocBlockClass
	text: string
}

export type DocBlockClass = 'TITLE' | 'HEADING_1' | 'HEADING_2' | 'HEADING_3' | 'HEADING_4' | 'HEADING_5' | 'HEADING_6' | 'NORMAL_TEXT'
